// src/components/Header.jsx
import '../App.css';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

// Header is now a presentational component that receives app state from App.js
const Header = ({ isAdmin, user, isMobile, showMobileMenu, setShowMobileMenu, handleLogout, setShowLoginPrompt }) => {
    const [showMore, setShowMore] = useState(false);
    const location = useLocation();
    const path = (location.pathname || '').replace(/\/+$/, '');
    const isActive = (key) => {
      const r = ROUTES[key];
      if (!r || !r.path) return false;
      const base = r.path.replace(/\/+$/, '');
      // active if exact match or if the path starts with the base (for nested routes)
      return path === base || (base !== '' && path.startsWith(base + '/'));
    };

    return (
        <header className="bg-gradient-to-r from-indigo-100 via-white to-indigo-100 shadow-lg">
            <div className="container mx-auto px-6 py-6 flex justify-between items-center max-w-4xl rounded-b-xl">
        {/* Logo → Link to Home (SPA) */}
        <Link
          to={normalizeRoute(ROUTES.humanizer?.path || '/')}
          aria-label="Home — OneAI Humanizer"
          className="site-logo flex items-center gap-3"
        >
          <img src="/logo192.png" srcSet="/logo512.png 2x" alt="OneAI Humanizer" width="48" height="48" style={{borderRadius:8}} />
          <p className="site-title" style={{margin:0}}>AI Text Humanizer</p>
        </Link>

                {/* Navigation Links */}
                <nav className={`flex gap-4 items-center nav ${isMobile && showMobileMenu ? 'open' : ''}`} aria-label="Primary Navigation">
                    <Link to={normalizeRoute(ROUTES.humanizer?.path || '/')} className={isActive('humanizer') ? 'nav-item active' : 'nav-item'}>Humanizer</Link>
                    <Link to={normalizeRoute(ROUTES.blogBuilder?.path || '/blog-builder/')} className={isActive('blogBuilder') ? 'nav-item active' : 'nav-item'}>Blog Builder</Link>
                    <Link to={normalizeRoute(ROUTES.tagGenerator?.path || '/tag-generator/')} className={isActive('tagGenerator') ? 'nav-item active' : 'nav-item'}>Tag Generator</Link>
                    <Link to={normalizeRoute(ROUTES.captionGenerator?.path || '/caption-generator/')} className={isActive('captionGenerator') ? 'nav-item active' : 'nav-item'}>Caption Generator</Link>

                    <div style={{position:'relative'}}>
                      <button className={showMore ? 'nav-item active' : 'nav-item'} onClick={() => setShowMore(!showMore)}>More ▾</button>
                      {showMore && (
                        <div className="more-menu" onMouseLeave={() => setShowMore(false)}>
                          <Link to={normalizeRoute(ROUTES.blog?.path || '/blog/')} className="nav-item">Blog</Link>
                          <Link to={normalizeRoute(ROUTES.aiNews?.path || '/ai-news/')} className="nav-item">AI News</Link>
                          <Link to={normalizeRoute(ROUTES.donate?.path || '/donate/')} className="nav-item">Donate</Link>
                          <Link to={normalizeRoute(ROUTES.featureRequest?.path || '/feature-request/')} className="nav-item">Suggest a Feature</Link>
                          <Link to={normalizeRoute(ROUTES.contact?.path || '/contact/')} className="nav-item">Contact</Link>
                          <Link to={normalizeRoute(ROUTES.about?.path || '/about/')} className="nav-item">About</Link>
                          {isAdmin && <Link to={normalizeRoute(ROUTES.admin?.path || '/admin/')} className="nav-item">Admin</Link>}
                        </div>
                      )}
                    </div>

                    {/* Auth / Actions area */}
                    {user ? (
                      <div className="user-inline">
                        <img src={user.picture} alt={user.name || 'User avatar'} className="user-avatar" loading="lazy" />
                        <span className="user-name">Hi, {user.name}</span>
                        <button className="btn ghost" onClick={handleLogout}>Logout</button>
                      </div>
                    ) : (
                      // Render placeholder for Google button — App.js will mount the button into this node
                      <div id="google-login-button" className="google-btn-placeholder"></div>
                    )}

                    {isMobile && (
                      <button className="menu-toggle" onClick={() => setShowMobileMenu(!showMobileMenu)} aria-label="Toggle menu">☰</button>
                    )}
                </nav>
            </div>
        </header>
    );
};

export default Header;
